function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "facebook-[#176]",
    opacity: 0.54,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.33698 18.58V10.219H8.87537L9.29 6.503H6.33698V4.69308C6.33698 3.73621 6.36142 2.787 7.69853 2.787H9.05282V0.130187C9.05282 0.09024 7.88952 0 6.71265 0C4.25481 0 2.71584 1.53953 2.71584 4.36648V6.503H0V10.219H2.71584V18.58H6.33698Z",
    fill: "white",
    style: {
      fill: "white",
      fill: "white",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.de2630da1b2a7e160d850d2d8a500b70.svg";
export { ForwardRef as ReactComponent };